import { FuelType } from 'ClientPortal/src/pages/Dashboard/FuelTypeChart/FuelTypeChart'

export type ColoredFuelType = FuelType & {
    id: string
    label: string
    value: number
    color: string
}

export const getDynamicColorsArray = (data: FuelType[], palette: string[]): ColoredFuelType[] => {
    return data
        .sort((a, b) => b.count - a.count)
        .map((fuelType, index) => {
            const color = palette[index % palette.length]
            return {
                id: fuelType.fuel_type.toUpperCase(),
                label: fuelType.fuel_type,
                value: fuelType.count,
                color,
                count: fuelType.count,
                fuel_type: fuelType.fuel_type,
            }
        })
}
